import { useState } from 'react';

import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Tab,
  Tabs,
  Typography,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import HeaderComp from '../../components/elements/HeadingComponent';

const PaymentHistory = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <Box>
      <HeaderComp>Payment & History</HeaderComp>

      {/* Back Button */}
      <Box
        display="flex"
        alignItems="center"
        mb={4}
        sx={{
          cursor: 'pointer',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateX(-4px)',
          },
        }}
        onClick={handleBackClick}
      >
        <IconButton
          size="small"
          sx={{
            backgroundColor: 'rgba(18, 112, 220, 0.1)',
            color: theme.palette.primary.main,
            mr: 1,
            '&:hover': {
              backgroundColor: 'rgba(18, 112, 220, 0.2)',
              transform: 'scale(1.1)',
            },
            transition: 'all 0.2s ease-in-out',
          }}
        >
          <ArrowBackIcon fontSize="small" />
        </IconButton>
        <Typography
          variant="body2"
          color="primary"
          sx={{
            fontWeight: 500,
            userSelect: 'none',
          }}
        >
          Back
        </Typography>
      </Box>

      {/* Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="Payment Management" />
          <Tab label="Transaction History" />
        </Tabs>
      </Box>

      {/* Tab Content */}
      {activeTab === 0 && (
        <Card
          sx={{
            background: '#fbfcfc',
            border: '1px solid',
            borderColor: 'rgba(0, 128, 128, 0.06)',
            borderRadius: 1.5,
            boxShadow: 'none',
          }}
        >
          <CardContent sx={{ p: 3 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                mb: 2,
                color: 'text.primary',
              }}
            >
              Payment Management
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'text.secondary',
                lineHeight: 1.6,
                mb: 3,
              }}
            >
              Manage your billing and payment settings:
            </Typography>
            <Box component="ul" sx={{ m: 0, pl: 2 }}>
              <Box component="li" sx={{ mb: 1, color: 'text.secondary' }}>
                Billing and subscription management
              </Box>
              <Box component="li" sx={{ mb: 1, color: 'text.secondary' }}>
                Payment processing and gateway integration
              </Box>
              <Box component="li" sx={{ mb: 1, color: 'text.secondary' }}>
                Invoice generation and management
              </Box>
              <Box component="li" sx={{ mb: 1, color: 'text.secondary' }}>
                Payment method management
              </Box>
              <Box component="li" sx={{ color: 'text.secondary' }}>
                Financial reporting and analytics
              </Box>
            </Box>
          </CardContent>
        </Card>
      )}

      {activeTab === 1 && (
        <Card
          sx={{
            background: '#fbfcfc',
            border: '1px solid',
            borderColor: 'rgba(0, 128, 128, 0.06)',
            borderRadius: 1.5,
            boxShadow: 'none',
          }}
        >
          <CardContent sx={{ p: 3 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                mb: 2,
                color: 'text.primary',
              }}
            >
              Transaction History
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'text.secondary',
                lineHeight: 1.6,
                mb: 3,
              }}
            >
              View detailed transaction logs and activity history:
            </Typography>
            <Box component="ul" sx={{ m: 0, pl: 2 }}>
              <Box component="li" sx={{ mb: 1, color: 'text.secondary' }}>
                Detailed transaction logs and audit trails
              </Box>
              <Box component="li" sx={{ mb: 1, color: 'text.secondary' }}>
                User activity monitoring and reporting
              </Box>
              <Box component="li" sx={{ mb: 1, color: 'text.secondary' }}>
                System event tracking and notifications
              </Box>
              <Box component="li" sx={{ mb: 1, color: 'text.secondary' }}>
                Export and download capabilities
              </Box>
              <Box component="li" sx={{ color: 'text.secondary' }}>
                Advanced filtering and search functionality
              </Box>
            </Box>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default PaymentHistory;
